import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createContext, useMemo } from '@wordpress/element';
export const BlockRefs = createContext({
  refs: new Map(),
  callbacks: new Map()
});
export function BlockRefsProvider(_ref) {
  let {
    children
  } = _ref;
  const value = useMemo(() => ({
    refs: new Map(),
    callbacks: new Map()
  }), []);
  return createElement(BlockRefs.Provider, {
    value: value
  }, children);
}
//# sourceMappingURL=block-refs-provider.js.map